import { IRecipeProduct, LogicalOperatorsBetweenProducts, Product } from 'hooks/useCannectAssistant/types'
import Button from 'new-components/Button'
import Input from 'new-components/Input'
import { ChangeEvent, FormEvent, useState } from 'react'
import api from 'services/api'
import { fromPrescriptionToApiProducts } from '../../helpers'
import * as Styles from './styles'

interface SaveTemplateModalProps {
  isOpen: boolean
  onRequestClose: () => void
  prescriptionProducts: Product[]
  logicalOperators: LogicalOperatorsBetweenProducts[]
  recommendation: string
  saveTemplate: (name: string, recommendation: string, products: IRecipeProduct[]) => void
}

export default function SaveTemplateModal({
  isOpen,
  onRequestClose,
  recommendation,
  prescriptionProducts,
  logicalOperators,
  saveTemplate
}: SaveTemplateModalProps) {
  const [name, setName] = useState('')
  const [nameErrorMessage, setNameErrorMessage] = useState('')
  const [isCheckingName, setIsCheckingName] = useState(false)

  const isNameAlreadyUsed = async (name: string): Promise<boolean> => {
    const trimmedName = name.trim()
    const { data } = await api.get(`/templates?search=${encodeURIComponent(trimmedName)}`)
    const rows: Array<{ name?: string }> = data?.templates?.rows ?? []
    return rows.some((template) => (template.name ?? '').trim().toLowerCase() === trimmedName.toLowerCase())
  }

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()

    if (name.trim().length === 0) {
      setNameErrorMessage('O nome do modelo é obrigatório')
      return
    }

    setIsCheckingName(true)
    try {
      if (await isNameAlreadyUsed(name)) {
        setNameErrorMessage('Já existe um modelo com esse nome. Escolha outro nome para salvar este modelo.')
        return
      }
    } catch (err) {
      // Se a verificação falhar, não bloqueia o salvamento
      console.error(err)
    } finally {
      setIsCheckingName(false)
    }

    const products = fromPrescriptionToApiProducts(prescriptionProducts, logicalOperators)
    saveTemplate(name, recommendation, products)
    onRequestClose()
  }

  const onNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value)
    setNameErrorMessage('')
  }

  return (
    <Styles.SaveTemplateModalContainer isOpened={isOpen} onRequestClose={onRequestClose}>
      <Styles.SaveTemplateForm onSubmit={onSubmit}>
        <h1>Cadastro de modelos</h1>
        <Input
          label="Nome do modelo"
          placeholder="Digite aqui um nome para seu modelo de receita"
          value={name}
          errorMessage={nameErrorMessage}
          onChange={onNameChange}
        />
        <Styles.SaveTemplateButtons>
          <Button background="green" type="button" isOutlined onClick={onRequestClose}>
            CANCELAR
          </Button>
          <Button background="green" type="submit" disabled={isCheckingName}>
            {isCheckingName ? 'VERIFICANDO...' : 'SALVAR'}
          </Button>
        </Styles.SaveTemplateButtons>
      </Styles.SaveTemplateForm>
    </Styles.SaveTemplateModalContainer>
  )
}
